import React, { useEffect } from 'react';

const isDevEnvironment = () => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname === 'dev.schneller-wohnen.net';
};

const DevIndicator: React.FC = () => {
  useEffect(() => {
    if (isDevEnvironment()) {
      const originalTitle = document.title;
      document.title = `[DEV] ${originalTitle}`;
      return () => { document.title = originalTitle; };
    }
  }, []);

  if (!isDevEnvironment()) return null;

  return (
    <div
      aria-hidden="true"
      data-dev-indicator
      className="pointer-events-none fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden"
    >
      <div
        className="whitespace-nowrap select-none text-danger-text/10"
        style={{
          fontSize: '8rem',
          fontWeight: 900,
          transform: 'rotate(-30deg)',
          letterSpacing: '0.2em',
        }}
      >
        DEV DEV DEV
      </div>
    </div>
  );
};

export { isDevEnvironment };
export default DevIndicator;
